module.exports = __webpack_public_path__ + "img/derbund.e3c512ec.png";